import React, { FC, useId } from 'react';

import {
	EvFlexColumn,
	EvFlexRow,
	EvHeadingSmall,
	EvInfoTooltip,
	EvLabelDefault,
	EvTextArea,
	EvTextInput,
	TEXT_COLOR
} from '@evinced-private/ui-common';

import {
	LABEL_MANAGEMENT_PANEL_DESCRIPTION_INPUT_DAID,
	LABEL_MANAGEMENT_PANEL_DISPLAY_NAME_INPUT_DAID
} from 'data-automation-ids/LabelManagementAutomationIds';

import { LABEL_PANEL_VALIDATION } from '../../LabelPanel.utils';

import { DESCRIPTION_TEXTAREA_ROWS } from './LabelDetailsSection.constants';
import { LABEL_DETAILS_LABELS } from './LabelDetailsSection.labels';
import { CoreLabelDetailsSectionProps } from './LabelDetailsSection.types';

export const CoreLabelDetailsSection: FC<CoreLabelDetailsSectionProps> = ({
	displayName,
	description,
	onDisplayNameChange,
	onDescriptionChange,
	displayNameError,
	descriptionError
}) => {
	const displayNameId = useId();

	return (
		<EvFlexColumn gap="LARGE">
			<EvHeadingSmall as="h3" color={TEXT_COLOR.CONTENT_2}>
				{LABEL_DETAILS_LABELS.SECTION_TITLE}
			</EvHeadingSmall>
			<EvFlexColumn gap="SMALL">
				<EvFlexRow align="CENTER" gap="SMALL">
					<EvLabelDefault as="label" htmlFor={displayNameId}>
						{LABEL_DETAILS_LABELS.DISPLAY_NAME_LABEL}
					</EvLabelDefault>
					<EvInfoTooltip title={LABEL_DETAILS_LABELS.DISPLAY_NAME_LABEL}>
						{LABEL_DETAILS_LABELS.DISPLAY_NAME_TOOLTIP}
					</EvInfoTooltip>
				</EvFlexRow>
				<EvTextInput
					id={displayNameId}
					value={displayName}
					onChange={onDisplayNameChange}
					isRequired
					error={displayNameError}
					dataAutomationId={LABEL_MANAGEMENT_PANEL_DISPLAY_NAME_INPUT_DAID}
				/>
			</EvFlexColumn>
			<EvTextArea
				label={LABEL_DETAILS_LABELS.DESCRIPTION_LABEL}
				tooltip={LABEL_DETAILS_LABELS.DESCRIPTION_TOOLTIP}
				value={description}
				onChange={(e) => onDescriptionChange(e.target.value)}
				placeholder={LABEL_DETAILS_LABELS.DESCRIPTION_PLACEHOLDER}
				maxLength={LABEL_PANEL_VALIDATION.DESCRIPTION_MAX_LENGTH}
				dataAutomationId={LABEL_MANAGEMENT_PANEL_DESCRIPTION_INPUT_DAID}
				error={descriptionError}
				rows={DESCRIPTION_TEXTAREA_ROWS}
				hint={LABEL_DETAILS_LABELS.DESCRIPTION_HINT}
			/>
		</EvFlexColumn>
	);
};
